<button mat-icon-button class="close-button" (click)="closeDialog()" id="surveyDialog-button-close">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<mat-card class="mat-elevation-z0">
  <mat-card-title>Future Initiative Form</mat-card-title>
  <mat-card-subtitle>Please tell us about an upcoming initiative at your company. It should take less than 3 minutes.</mat-card-subtitle>

  <mat-card-content>
    <mat-horizontal-stepper labelPosition="bottom" linear=true #stepper >
      <mat-step [stepControl]="formGroup1" label="Project">
        <form [formGroup]="formGroup1">
          <!--Radio Group-->
          <div class="survey-group" id="surveyDialog-radioGroup-1">
            <label class="radio-group-label">{{this.findQuestions('radioGroup1').title}}
              <span style="color: #ff0000" *ngIf="formGroup1.get('radioGroup1').touched && formGroup1.get('radioGroup1').invalid">
                * required
              </span>
            </label>
              <mat-radio-group class="radio-group" formControlName="radioGroup1" required>
                <ul>
                  <li *ngFor="let radioButtonValue of this.findQuestions('radioGroup1').elementValue">
                    <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue" (change)="onRadioGroup1ItemChange(radioButtonValue)" >
                      {{radioButtonValue}}
                    </mat-radio-button>
                  </li>
                </ul>
                <mat-form-field class="example-full-width" appearance="outline" *ngIf="isVisibleCustomSpecify">
                  <mat-label>Specify</mat-label>
                  <input matInput placeholder="Write text..." formControlName="customSpecify">
                </mat-form-field>
              </mat-radio-group>
          </div>
          <!--Radio Group-->
          <div class="survey-group" id="surveyDialog-radioGroup-2">
              <label class="radio-group-label">{{findQuestions('radioGroup2').title}}
                <span style="color: #ff0000" *ngIf="formGroup1.get('radioGroup1').touched && formGroup1.get('radioGroup2').invalid">
                  * required</span></label>
              <mat-radio-group class="radio-group" formControlName="radioGroup2" required>
                <ul style="display: flex;flex-direction: row" >
                  <li *ngFor="let radioButtonValue of findQuestions('radioGroup2').elementValue">
                    <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue">
                      {{radioButtonValue}}
                    </mat-radio-button>
                  </li>
                </ul>
              </mat-radio-group>
            </div>
          <!--Radio Group-->
          <div class="survey-group" id="surveyDialog-radioGroup-3">
              <label class="radio-group-label">{{findQuestions('radioGroup3').title}}</label>
              <mat-radio-group class="radio-group" formControlName="radioGroup3">
                <ul>
                  <li *ngFor="let radioButtonValue of findQuestions('radioGroup3').elementValue">
                    <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue" (change)="onRadioGroup3ItemChange(radioButtonValue)">
                      {{radioButtonValue}}
                    </mat-radio-button>
                  </li>
                </ul>
              </mat-radio-group>
            </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="formGroup6" label="Replacing" *ngIf="isVisibleStep2">
        <form [formGroup]="formGroup6">
          <div class="survey-group">
            <label class="radio-group-label" >{{findQuestions('inputText1').title}}</label>
            <mat-form-field appearance="fill" style="width: 100%" id="surveyDialog-input-provider">
              <input matInput placeholder="Example: ProviderName" formControlName="inputText1">
              <mat-hint>Write answer ...</mat-hint>
            </mat-form-field>
          </div>
          <div class="survey-group" id="surveyDialog-radioGroup-4">
            <label class="radio-group-label" >{{findQuestions('radioGroup6').title}}</label>
            <mat-radio-group class="radio-group" formControlName="radioGroup6">
              <ul class="ul-column">
                <li *ngFor="let radioButtonValue of findQuestions('radioGroup6').elementValue">
                  <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue" (click)="onRadioGroup6ItemChange(radioButtonValue)">
                    {{radioButtonValue}}
                  </mat-radio-button>
                </li>
              </ul>
              <mat-form-field class="example-full-width" appearance="outline" *ngIf="isVisibleOther">
                <mat-label>Other</mat-label>
                <input matInput placeholder="Write text..." formControlName="other" >
              </mat-form-field>
            </mat-radio-group>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="formGroup2" label="Product / Service">
        <form [formGroup]="formGroup2"  >
            <!--Radio Group-->
            <div class="survey-group" id="surveyDialog-radioGroup-5">
              <label class="radio-group-label" >{{findQuestions('radioGroup4').title}}</label>
              <mat-radio-group class="radio-group" formControlName="radioGroup4">
                <ul>
                  <li *ngFor="let radioButtonValue of findQuestions('radioGroup4').elementValue">
                    <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue">
                      {{radioButtonValue}}
                    </mat-radio-button>
                  </li>
                </ul>
              </mat-radio-group>
            </div>
            <!--Chips Group-->
            <div class="survey-group" id="surveyDialog-chipsGroup-1">
              <label class="radio-group-label" >{{findQuestions('chipsAutocomplete1').title}} <span style="color: red">*</span></label>
              <chips-autocomplete-input formControlName="autocomplete1" [startSelectedValues]="startSelectedValuesAutocomplete1" [values]="category"  [required]="true"></chips-autocomplete-input>
            </div>
            <div class="survey-group" id="surveyDialog-radioGroup-6">
              <label class="radio-group-label">{{findQuestions('inputText2').title}} </label>
              <mat-form-field appearance="fill" style="width: 100%">
                <input matInput placeholder="Example: Reebok" formControlName="inputText2">
                <mat-hint>Write answer ...</mat-hint>
              </mat-form-field>
            </div>

        </form>
      </mat-step>
      <mat-step [stepControl]="formGroup3" label="Timeline">
        <form [formGroup]="formGroup3" >
          <div class="survey-group" id="surveyDialog-radioGroup-7">
            <label class="radio-group-label" >{{findQuestions('radioGroup5').title}}</label>
            <mat-radio-group class="radio-group" formControlName="radioGroup5">
              <ul style="display: flex;flex-direction: row">
                <li *ngFor="let radioButtonValue of findQuestions('radioGroup5').elementValue">
                  <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue">
                    {{radioButtonValue}}
                  </mat-radio-button>
                </li>
              </ul>
            </mat-radio-group>
          </div>
          <div class="survey-group" *ngIf="findQuestions('radioGroup5').elementSelectedValue[0] == 'Yes'"  id="surveyDialog-radioGroup-8">
            <label class="radio-group-label">{{findQuestions('select3').title}}</label>
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Choose...</mat-label>
              <mat-select formControlName="select3">
                <mat-option *ngFor="let value of findQuestions('select3').elementValue" [value]="value">
                  {{value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="survey-group" *ngIf="findQuestions('radioGroup5').elementSelectedValue[0] == 'Yes'" id="surveyDialog-radioGroup-9">
            <label class="radio-group-label">{{findQuestions('select4').title}}</label>
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Choose...</mat-label>
              <mat-select formControlName="select4">
                <mat-option *ngFor="let value of findQuestions('select4').elementValue" [value]="value">
                  {{value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>

      </mat-step>
      <mat-step [stepControl]="formGroup4" label="Scope">
        <form [formGroup]="formGroup4" >
          <div class="survey-group"  id="surveyDialog-radioGroup-10">
            <label class="radio-group-label" >{{findQuestions('radioGroup7').title}}</label>
            <mat-radio-group class="radio-group" formControlName="radioGroup7">
              <ul style="display: flex;flex-direction: row">
                <li *ngFor="let radioButtonValue of findQuestions('radioGroup7').elementValue">
                  <mat-radio-button class="radio-button"  color="primary"  [value]="radioButtonValue" (change)="onRadioGroup7ItemChange(radioButtonValue)">
                    {{radioButtonValue}}
                  </mat-radio-button>
                </li>
              </ul>
            </mat-radio-group>
          </div>
          <div class="survey-group" *ngIf="findQuestions('radioGroup7').elementSelectedValue[0] == 'Yes'" id="surveyDialog-radioGroup-11">
            <label class="radio-group-label">{{findQuestions('select5').title}}</label>
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Choose...</mat-label>
              <mat-select formControlName="select5">
                <mat-option *ngFor="let value of findQuestions('select5').elementValue" [value]="value">
                  {{value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="survey-group" id="surveyDialog-radioGroup-12">
            <label class="radio-group-label">{{findQuestions('select1').title}}</label>
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Choose...</mat-label>
              <mat-select formControlName="select1">
                <mat-option *ngFor="let value of findQuestions('select1').elementValue" [value]="value">
                  {{value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </form>

      </mat-step>
      <mat-step [stepControl]="formGroup5" label="Team">
        <form [formGroup]="formGroup5" >
          <div class="survey-group" id="surveyDialog-radioGroup-13">
            <label class="radio-group-label">{{findQuestions('select2').title}}</label>
            <mat-form-field appearance="fill" style="width: 100%">
              <mat-label>Choose...</mat-label>
              <mat-select formControlName="select2" (selectionChange)="onSelect2ItemChange($event.value)">
                <mat-option *ngFor="let value of findQuestions('select2').elementValue" [value]="value">
                  {{value}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%" appearance="outline" *ngIf="this.findQuestions('select2').elementSelectedValue[0] == 'Other (describe)'">
              <mat-label>Other</mat-label>
              <input matInput placeholder="Write number..." formControlName="teamSpecify">
            </mat-form-field>
          </div>
          <div class="survey-group" id="surveyDialog-radioGroup-14">
            <label class="radio-group-label">{{findQuestions('chipsAutocomplete2').title}}</label>
            <chips-autocomplete-input formControlName="autocomplete2" [onlySingle]="true" [allowedNew]="true" [startSelectedValues]="startSelectedValuesAutocomplete2" [values]="contactsMaker" (onChanged)="findContactsMaker($event.searchQuery)" [required]="true"></chips-autocomplete-input>
          </div>
          <div class="survey-group" id="surveyDialog-radioGroup-15">
            <label class="radio-group-label">{{findQuestions('chipsAutocomplete3').title}}</label>
            <chips-autocomplete-input formControlName="autocomplete3" [startSelectedValues]="startSelectedValuesAutocomplete3" [values]="contacts" (onChanged)="findContacts($event.searchQuery)"></chips-autocomplete-input>
          </div>
        </form>
      </mat-step>
    </mat-horizontal-stepper>

  </mat-card-content>
  <mat-card-actions align="end">
    <button *ngIf="stepper.selectedIndex != 0" mat-raised-button  (click)="goBack(stepper)" id="surveyDialog-button-previous">Previous</button>
    <button *ngIf="stepper.selectedIndex != stepper.steps.length-1" mat-raised-button  color="primary" (click)="goForward(stepper)" id="surveyDialog-button-next">Next</button>
    <button *ngIf="stepper.selectedIndex === stepper.steps.length-1" mat-raised-button  color="primary" (click)="finishSurvey()"
            [disabled]="!formGroup1.valid || !formGroup2.valid || !formGroup3.valid || !formGroup4.valid || !formGroup5.valid || !formGroup6.valid" id="surveyDialog-button-finish">Finish</button>
  </mat-card-actions>
</mat-card>


